/**
 * External system correspondence: (systemKey + entityName + externalId) → localId.
 * Logical path: org/{orgId}/external-ref
 *
 * Technical mapping — no lifecycle, no audit (same convention as subcollections / 0096 §D1).
 */
export const EXTERNAL_REF = 'ExternalRef';
/**
 * Deterministic ExternalRef document id: `${systemKey}:${entityName}:${externalId}`.
 *
 * Firestore rejects `/` in document ids — path separators are replaced with `_`.
 * Uniqueness is guaranteed by this id; callers must not invent a second uniqueness check.
 */
export function externalRefId(systemKey, entityName, externalId) {
    return `${systemKey}:${entityName}:${externalId}`.replace(/\//g, '_');
}
//# sourceMappingURL=externalRef.js.map